export const findWhere = (list, properties) => {
  try {
    return list?.find(item => Object.keys(properties).every(key => item[key] === properties[key])) || null;
  } catch (e) {
    console.debug(`Failed to iterate over list: ${e.message}`);
  }
};
